
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import LoginPage from '../pages/login/page';
import AdminPage from '../pages/admin/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
